export default __webpack_public_path__ + "static/media/trending_up.c62e704b.svg";